module.exports = __webpack_public_path__ + "static/media/global-network.16e1c49c.svg";